export default __webpack_public_path__ + "static/mstile-150x150-3a8b66cf022c158692c7dc26728ea330.png";